import type { PersistedClient, Persister } from '@tanstack/react-query-persist-client'
import { saveQueryCache, loadQueryCache } from './idb-store'

/**
 * IndexedDB-backed persister for React Query.
 * Persists the dehydrated query cache so data survives page reload.
 */
export function createIDBPersister(): Persister {
  return {
    persistClient: async (client: PersistedClient) => {
      try {
        await saveQueryCache(JSON.stringify(client))
      } catch {
        // IndexedDB write failure is non-fatal
      }
    },
    restoreClient: async (): Promise<PersistedClient | undefined> => {
      try {
        const raw = await loadQueryCache()
        if (!raw) return undefined
        return JSON.parse(raw) as PersistedClient
      } catch {
        return undefined
      }
    },
    removeClient: async () => {
      try {
        await saveQueryCache('')
      } catch { /* non-fatal */ }
    },
  }
}
